/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { forwardRef } from 'react'
import cn from 'classnames'
import s from './toggle.module.css'
import type { ToggleProps } from './types'

const Input = (props: ToggleProps, ref: any) => {
  const { className, type, name, label, touched, error, inputClassName, ...rest } = props

  return (
    <div className={cn(s.root, className)}>
      <label htmlFor={name} className={s.container} role="button">
        <input type={type || 'checkbox'} name={name} className={cn(s.input, inputClassName)} ref={ref} {...rest} />
        <span className={s.dot} />
      </label>
      <span className={s.label}>{label}</span>
    </div>
  )
}

export default forwardRef(Input)
